import { createContext, useContext } from 'react';
import type { CalibrationStatus, ScreenInfo } from '../lib/calibration';

export interface CalibrationValue {
  status: CalibrationStatus;
  screen: ScreenInfo;
  save(pxPerCm: number): void;
  reset(): void;
}

export const CalibrationContext = createContext<CalibrationValue | null>(null);

export function useCalibration(): CalibrationValue {
  const v = useContext(CalibrationContext);
  if (!v) throw new Error('CalibrationProvider 밖에서 useCalibration을 사용했습니다.');
  return v;
}
